// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"63de0cc7","239":"c9af8467","455":"0833ecbe"}[chunkId] + ".chunk.js";
};